import { render, staticRenderFns } from "./serveTemp.vue?vue&type=template&id=b048241c&scoped=true&"
import script from "./serveTemp.vue?vue&type=script&lang=js&"
export * from "./serveTemp.vue?vue&type=script&lang=js&"
import style0 from "./serveTemp.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./serveTemp.vue?vue&type=style&index=1&id=b048241c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b048241c",
  null
  
)

component.options.__file = "serveTemp.vue"
export default component.exports